import React from 'react';
import { AlertCircle, RefreshCcw, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('[ErrorBoundary] Caught an error:', error, errorInfo);
    }

    handleRestart = () => {
        window.location.reload();
    };

    handleGoDashboard = () => {
        window.location.href = '/dashboard/user';
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-[400px] w-full flex items-center justify-center p-6">
                    <div className="max-w-md w-full glass-morphism rounded-3xl p-8 border border-white/10 shadow-2xl text-center space-y-6 animate-in fade-in zoom-in duration-300">
                        <div className="w-20 h-20 bg-red-500/10 rounded-full flex items-center justify-center mx-auto border border-red-500/20">
                            <AlertCircle className="w-10 h-10 text-red-500" />
                        </div>

                        <div className="space-y-2">
                            <h2 className="text-2xl font-bold text-white tracking-tight">Ops! Algo deu errado.</h2>
                            <p className="text-gray-400 text-sm leading-relaxed">
                                Ocorreu um erro inesperado nesta interface. Nossos sistemas já foram notificados.
                            </p>
                        </div>

                        <div className="p-4 bg-black/20 rounded-xl border border-white/5 text-left">
                            <p className="text-[10px] font-mono text-red-400/80 uppercase tracking-widest mb-1">Detalhes Técnicos</p>
                            <p className="text-xs font-mono text-gray-500 truncate">
                                {this.state.error?.message || 'Erro Interno do React'}
                            </p>
                        </div>

                        <div className="grid grid-cols-2 gap-3 pt-2">
                            <Button
                                onClick={this.handleRestart}
                                variant="outline"
                                className="rounded-xl border-white/10 hover:bg-white/5 gap-2"
                            >
                                <RefreshCcw className="w-4 h-4" />
                                Tentar Novamente
                            </Button>
                            <Button
                                onClick={this.handleGoDashboard}
                                className="rounded-xl bg-blue-600 hover:bg-blue-700 gap-2"
                            >
                                <Home className="w-4 h-4" />
                                Painel Inicial
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
